import { IAppStore } from '../../store';
import { brandingWrapper } from './component';

const mapStoresToProps = (stores: IAppStore) => ({
    ctrl: stores.withBrandingController
});

export default brandingWrapper(mapStoresToProps);